<template>
  <div class="main_select_page">
    <reSelect v-model="value" @on-open-change="onOpenChange" @on-change="onChange" loadingText="无数据">
      <Input v-model="searchValue" slot="search" ref="search"></Input>
      <Option v-for="item in resetOptions" :key="item.display" :value="item.value" :label="item.display"></Option>
    </reSelect>
  </div>
</template>
<script>
import reSelect from '@/components/reSelect/select.vue'
export default {
  name: 'mainSelect',
  components: { reSelect },
  data() {
    return {
      value: '',
      searchValue: '',
      flag: true
    }
  },
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    resetOptions() {
      return this.options.filter(item => {
        return item.display.indexOf(this.searchValue) !== -1
      })
    }
  },
  methods: {
    onOpenChange(flag) {
      if (flag) {
        this.searchValue = ''
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    onChange() {
      this.resetOptions.forEach(item => {
        if (item.value === this.value) {
          this.$emit('reset', {
            value: item.value,
            type: item.type
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .main_select_page {
    display: inline-block;
    margin-right: 20px;
    .ivu-select {
      width: 220px;
      .ivu-input-wrapper {
        padding: 0 5px;
        .ivu-input {
          border: 1px solid #ccc;
        }
      }
      .ivu-select-dropdown {
        max-height: 300px;
        overflow: inherit;
        .yjh-scroll {
          overflow-y: auto;
          max-height: 250px;
        }
      }
    }
  }
</style>
